import React, { useState } from "react";
import { Link } from "react-router-dom";

const LinkButton = ({
  className,
  linkTo,
  children,
  zoom,
  backgroundColor,
  color,
  width,
  maxWidth,
  minWidth,
}) => {
  let transform = "scale(1)";

  if (zoom === true) {
    transform = "scale(1.05)";
  } else {
    transform = "scale(1)";
  }

  const [linkButtonStyle, setLinkButtonStyle] = useState({
    textDecoration: "none",
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth,
    padding: 15,
    borderRadius: 15,
    border: "none",
    backgroundColor: backgroundColor,
    color: color,
    cursor: "pointer",
    fontWeight: 700,
    transition: "transform .2s",
  });
  return (
    <Link to={linkTo}>
      <button
        className={className}
        style={linkButtonStyle}
        onMouseOver={() => {
          setLinkButtonStyle({
            textDecoration: "none",
            width: width,
            maxWidth: maxWidth,
            minWidth: minWidth,
            padding: 15,
            borderRadius: 15,
            border: "none",
            backgroundColor: backgroundColor,
            color: color,
            cursor: "pointer",
            fontWeight: 700,
            transition: "transform .1s",
            transform: transform,
          });
        }}
        onMouseLeave={() => {
          setLinkButtonStyle({
            textDecoration: "none",
            width: width,
            maxWidth: maxWidth,
            minWidth: minWidth,
            padding: 15,
            borderRadius: 15,
            border: "none",
            backgroundColor: backgroundColor,
            color: color,
            cursor: "pointer",
            fontWeight: 700,
            transition: "transform .1s",
            transform: "scale(1)",
          });
        }}
      >
        {children}
      </button>
    </Link>
  );
};

export default LinkButton;
